import ECheckRowDesktop from './ECheckRowDesktop';

export default ECheckRowDesktop;
